import { render, staticRenderFns } from "./Moviegoers.vue?vue&type=template&id=55431b4d&scoped=true"
import script from "./Moviegoers.vue?vue&type=script&lang=js"
export * from "./Moviegoers.vue?vue&type=script&lang=js"
import style0 from "./Moviegoers.vue?vue&type=style&index=0&id=55431b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55431b4d",
  null
  
)

export default component.exports